import ConfigurableText from './_configurable-text.js'
import ConfigurablePane from './_configurable-pane.js'
import FlexPane from './_flex-pane.js'
import FixedWidthTime from './_fixed-width-time.js'
import Text from './_text.js'

export default {
  name: 'Timer',
  values: {
    style: {
      extendedTime: {
        display: 'inline-block',
        minWidth: '14px',
        maxWidth: '14px',
        textAlign: 'right',
        padding: '0 2px 0 0',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurablePane,
          },
        ],
      },
    },
    timerWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexDirection: 'row',
        },
      },
    },
    timerFourDigits: {
      configSet: FixedWidthTime,
      configValues: {
        timeBox: {
          style: {
            minWidth: '34px',
          },
        },
      },
    },
    timerFiveDigits: {
      configSet: FixedWidthTime,
      configValues: {
        timeBox: {
          style: {
            minWidth: '40px',
          },
        },
      },
    },
    startTimeLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: '0 4px 0 0',
        },
      },
    },
    isExtendedFormat: false,
    hoursWrapper: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: 0,
        },
      },
    },
    minutesWrapper: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: '0 0 0 4px',
        },
      },
    },
    secondsWrapper: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: '0 0 0 4px',
        },
      },
    },
    timeString: {
      configSet: FlexPane,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
